import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./promission";

import * as filters from "@/filters"; // global filters
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$getMenuIdByCode = function (code) {
  const menuItem =
    store.state.permission.allMenusList.find((item) => item.code === code) ||
    {};
  return menuItem.id;
};

import ElementUI from "element-ui";
Vue.use(ElementUI);

import VueSuperSlide from "vue-superslide";
Vue.use(VueSuperSlide);

// import "element-ui/lib/theme-chalk/index.css";
import "@/assets/styles/index.scss"; // global css

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
